import { motion } from "framer-motion";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Database } from "lucide-react";

export function DataPreview({ columns, rows, totalRows }) {
  const previewRows = rows.slice(0, 5);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      data-testid="data-preview-section"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Database className="w-4 h-4 text-primary" />
          <h3 className="text-sm font-bold tracking-wide uppercase text-zinc-500">
            Aperçu des données
          </h3>
        </div>
        <div className="flex gap-2">
          <Badge variant="outline" className="text-xs font-mono" data-testid="total-rows-badge">
            {totalRows} lignes
          </Badge>
          <Badge variant="outline" className="text-xs font-mono" data-testid="total-columns-badge">
            {columns.length} colonnes
          </Badge>
        </div>
      </div>

      <div className="rounded-xl border border-zinc-200 overflow-hidden" data-testid="data-preview-table">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-zinc-50 hover:bg-zinc-50">
                {columns.map((col) => (
                  <TableHead
                    key={col}
                    className="text-xs font-bold uppercase tracking-wider text-zinc-500 py-3 px-4 whitespace-nowrap"
                  >
                    {col}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {previewRows.map((row, i) => (
                <TableRow key={i}>
                  {columns.map((col) => (
                    <TableCell
                      key={col}
                      className="py-3 px-4 text-sm font-mono text-zinc-600 whitespace-nowrap"
                    >
                      {String(row[col] ?? "")}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      {totalRows > 5 && (
        <p className="text-xs text-zinc-400 mt-2 text-right">
          Affichage des 5 premières lignes sur {totalRows}
        </p>
      )}
    </motion.div>
  );
}
